import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, JhiLanguageService } from 'ng-jhipster';

import { User, UserService } from '../../shared';
import { UserEchangeModalService } from './user-echange-modal.service';
import {UserEnEchangeService} from '../../entities/user-en-echange';

@Component({
    selector: 'jhi-user-echange-delete-dialog',
    templateUrl: './user-echange-delete-dialog.component.html'
})
export class UserEchangeMgmtDeleteDialogComponent {

    user: User;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private userService: UserEnEchangeService,
        public activeModal: NgbActiveModal,
        private eventManager: EventManager
    ) {
        this.jhiLanguageService.setLocations(['user-echange']);
    }

    clear () {
        this.activeModal.dismiss('cancel');
    }

    confirmDelete (id) {
        this.userService.delete(id).subscribe(response => {
            this.eventManager.broadcast({ name: 'userListModification',
                content: 'Supprimer un étudiant en échange'});
            this.activeModal.dismiss(true);
        });
    }

}

@Component({
    selector: 'jhi-user-echange-delete-dialog',
    template: ''
})
export class UserEchangeDeleteDialogComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor (
        private route: ActivatedRoute,
        private userModalService: UserEchangeModalService
    ) {}

    ngOnInit() {
        this.routeSub = this.route.params.subscribe(params => {
            this.modalRef = this.userModalService.open(UserEchangeMgmtDeleteDialogComponent, params['id']);
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/admin/user-echange/user-echange-delete-dialog.component.ts